import { RangeSlider as RangeSliderComponent } from './RangeSlider';

export const RangeSlider = RangeSliderComponent;
